// extracted by mini-css-extract-plugin
export const page = "products-module--page--KvYuE";